// extracted by mini-css-extract-plugin
export default {"lead__Approval__View":"styles_lead__Approval__View__TvFm2","back__Btn__Wrap":"styles_back__Btn__Wrap__u3OOq","back__Btn":"styles_back__Btn__Blo60"};